module.exports = __webpack_public_path__ + "img/student-growth.3b638fed.png";